import { doc, getDoc } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { ReportData } from './types';
import { validateReportData } from './validation';
import { handleReportError } from './error';
import { getUserData } from '@/services/database';
import { transformReportData } from './transforms'; 
import { mockReportData } from './mock';

export async function fetchReportData(userId: string): Promise<ReportData> {
  if (!userId) {
    throw new Error('User ID is required');
  }

  try {
    // First check if user has completed all requirements
    const userData = await getUserData(userId);
    
    if (!userData.reportAvailable) {
      throw new Error('Report is not available yet. Please complete all evaluations first.');
    }

    // Return mock data if report is available but no actual report exists yet
    try {
      const reportRef = doc(db, collections.reports, userId);
      const reportDoc = await getDoc(reportRef);

      if (reportDoc.exists()) {
        const rawData = reportDoc.data();
        
        if (!rawData?.reportData || typeof rawData.reportData !== 'string') {
          return mockReportData;
        }

        try {
          // Parse report data
          let parsedData = JSON.parse(rawData.reportData);
          
          // Parse DISC data if available
          if (rawData.discData && typeof rawData.discData === 'string') {
            parsedData.discResults = JSON.parse(rawData.discData);
          }

          // Transform and validate the parsed data
          const transformedData = transformReportData(parsedData);
          validateReportData(transformedData);

          return transformedData;
        } catch (e) {
          return mockReportData;
        }
      }

      // Return mock data if no report document exists
      return mockReportData;
    } catch (error) {
      // Return mock data if there's any error fetching the report
      return mockReportData;
    }
  } catch (error) {
    throw handleReportError(error);
  }
}